/**
 * Every English label on the staff-facing screens, in one list.
 *
 * The backend translates and caches these once per language. Add a string
 * here whenever you wrap a new literal in `t(...)`.
 */
export const UI_STRINGS = [
  // page header
  'My Performance',
  "Your goals for this half-year, how you're tracking, and your appraisal.",
  'Language',
  'Appraisal PDF',
  'PDF',
  'Preparing…',
  'Final score',
  'Manager',
  'Your score unlocks once management publishes this cycle.',
  'Your appraisal letter can be downloaded once this cycle is published',
  "This login isn't linked to a staff record yet — ask the admin to add you to the Staff Master.",
  'No review cycle assigned to you yet. Your manager will set your goals soon.',

  // activity strip
  'My activity this cycle',
  'as of',
  'Jobs completed',
  'On-time delivery',
  'Inspections',
  'Attendance',
  'Days present',
  'OT hours',
  'Teammates lifted',

  // goals + self review
  'My goals',
  'Your note on this goal (optional)',
  'Published',
  'Goals Set',
  'Self Submitted',
  'Manager Submitted',
  'Update self review',
  'Goal',
  'Weight',
  'Target',
  'Actual',
  'Achieved',
  'My note',
  'What I did',
  'How I rate myself',
  'Submit self review',
  'Submitted',
  'Your self review has been submitted — your manager will review it next.',
  'Anything else you want on record',
  'Save draft',
  'Behaviours',
  'Self',

  // manager side
  "Manager's feedback",
  'No written feedback was recorded.',
  'Next steps',
  'Recommendation',
  'Strengths',
  'Where to improve',

  // skills card
  'My skill map',
  'assessed',
  'Awaiting supervisor sign-off',
  'Skill index',
  'My progress',
  'vs previous assessment',
  'Assessor remarks',
  'Training needs',
  'Focus next',
  'My skill certificate',
  'How my skills are assessed',
  'the rating scale and every skill I can be measured on',
  'Your appraisal keeps using the last approved assessment until this one is signed off.',

  // training
  'My training',
  "Skills I'm learning",
  "I'm training others on",
  'Trainer to be assigned',
  'due',
  'open',
  'Trainer',
  'Target',
  'OK',
  'Expert — can train others',
  'in progress',
  'done',
  'cancelled',

  // acknowledgement
  'I have discussed and understood my appraisal',
  'Acknowledge',
  'You acknowledged this appraisal on',
  'Your note',
  'It now shows on your appraisal letter — no signature needed.',
  'Add a note (optional)',
  'My score history',

  // module guide
  'How this module works',
  'every feature of the appraisal system, in one place',

  // self assessment + outcome
  'My self assessment',
  'Rate yourself 1 (low) to 5 (excellent). Your manager sees this before scoring.',
  "Anything you'd like management to know",
  'Appraisal outcome',
  'To improve',
  'Management',
  'Approved increment',
  'No goals set yet.',
  "I'm training others in",
  'Checked by supervisor',
  'Approved',
];

export default UI_STRINGS;
